module.exports = __webpack_public_path__ + "media/images/demo_tests/grillmaster-5aafd2bbda58f90e7fc5b170092e8bc6.png";